module.exports = __webpack_public_path__ + "static/media/empresaoriginal-logo-white.aa4439e8.png";